import { farasod } from "./api"

const endpoint = "/tax"

export const getTaxes = async () => {
  const response = await farasod.get(`${endpoint}`)

  return response.data
}

export const addTax = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const editTax = async (taxId, data) => {
  const response = await farasod.patch(`${endpoint}/${taxId}`, data)

  return response.data
}

export const deleteTax = async (taxId) => {
  const response = await farasod.delete(`${endpoint}/${taxId}`)

  return response.data
}